export const theme = {
  color: {
    black: "#000",
    silver: "#ccc",
    alto: "#ddd",
    gallery: "#eee",
    white: "#fff",
    teal: "#008080",
    lightTeal: "#b2d8d8",
    crimson: "#db143c",
    forestGreen: "#228c22",
  },
  breakpoint: {
    mobileMax: 767,
  },
};
